import { FlagsmithClientProvider } from '@openfeature/flagsmith-client-provider';
import { OpenFeature } from '@openfeature/react-sdk';
import { currentClient } from './currentClient';
import { currentUser } from './currentUser';
import { currentApplication } from './currentApplication';

export function initFeatureFlagging() {
    const flagsmithEnvId = process.env.FLAGSMITH_API_KEY || ''; //eslint-disable-line no-undef

    // This environment ID will be set using ENV variables once they are set up
    const flagsmithClientProvider = new FlagsmithClientProvider({
        environmentID: flagsmithEnvId,
    });

    OpenFeature.setProvider(flagsmithClientProvider);

    let lastContext = {};

    // This function checks if the context has changed and updates it if needed
    const checkAndUpdateFeatureContext = () => {
        const client_slug = currentClient.getValue()?.slug;
        const client_id = currentClient.getValue()?.id;
        const user_email = currentUser.getValue()?.email;
        const user_id = currentUser.getValue()?.id;
        const application_id = currentApplication.getValue()?.id;

        if (!client_slug || !user_email || !application_id) return;

        const newContext = {
            targetingKey: user_id,
            traits: {
                client_slug: client_slug,
                client_id: client_id,
                user_email: user_email,
                user_id: user_id,
                application_id: application_id,
            },
        };

        // Update context only if it has changed
        if (JSON.stringify(newContext) !== JSON.stringify(lastContext)) {
            lastContext = newContext;
            OpenFeature.setContext(newContext);
        }
    };

    checkAndUpdateFeatureContext();

    currentClient.subscribe(() => checkAndUpdateFeatureContext());
    currentUser.subscribe(() => checkAndUpdateFeatureContext());
    currentApplication.subscribe(() => checkAndUpdateFeatureContext());

    return () => {
        currentClient.unsubscribe();
        currentUser.unsubscribe();
        currentApplication.unsubscribe();
    };
}
